var map = {
	"./blog.yml": 159,
	"./cloud.yml": 160,
	"./color.yml": 161,
	"./country.yml": 162,
	"./dio.yml": 163,
	"./doc.yml": 164,
	"./emoji.yml": 165,
	"./git.yml": 166,
	"./icon.yml": 167,
	"./license.yml": 168,
	"./link.yml": 169,
	"./metrics.yml": 170,
	"./people.yml": 171,
	"./soft.yml": 172,
	"./src.yml": 173,
	"./status.yml": 174
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 158;